<template>
    <div  class="tw-bg-white tw-py-8 tw-pb-10 tw-px-6 tw-rounded tw-border tw-border-solid tw-border-gray-200 tw-text-center tw-w-full">
      <!-- Badge Icons Aligned with Progress Bar -->
      <div class="tw-relative tw-mb-3">
        <div class="tw-flex tw-justify-between tw-w-full">
          <div v-for="(badge, index) in badges" :key="index" class="tw-relative tw-flex tw-flex-col tw-items-center">
            <!-- Star Ribbon Above Badge -->
            <div v-if="badge.stars" class="tw-absolute tw-z-10 tw-top-[-14px] tw-px-2 tw-py-1 tw-bg-black/80 tw-text-yellow-400 tw-rounded-full tw-flex tw-items-center tw-gap-1">
              <icon icon="mdi:star" v-for="n in badge.stars" :key="n" class="tw-text-sm" />
            </div>
  
            <!-- Badge Icon -->
            <div class="tw-relative tw-w-16 tw-h-16 tw-flex tw-items-center tw-justify-center tw-rounded-full tw-shadow-md tw-border-4 tw-border-white"
                 :class="badge.bgColor">
              <icon :icon="badge.icon" class="tw-text-3xl" :class="badge.iconColor" />
            </div>
  
            <!-- Arabic Label & Number - Improved Alignment -->
            <div class="tw-mt-2 tw-text-sm tw-font-semibold tw-text-gray-800 tw-flex tw-flex-col tw-items-center">
              <span>{{ $t(badge.label) }}</span>
              <span v-if="badge.number && false" class="tw-text-xs tw-font-bold tw-text-gray-600 tw-bg-gray-100 tw-px-2 tw-py-1 tw-rounded-md">
                {{ badge.number }}
              </span>
            </div>
          </div>
        </div>
      </div>
  
      <!-- Range Labels Above Progress Bar -->
      <div v-if="true" class="tw-flex tw-justify-between tw-mb-5 ">
        <div v-for="(range, index) in ranges" :key="index" class="tw-min-w-[67px] tw-flex tw-justify-center">
            <span  class="tw-text-xs tw-font-bold tw-text-gray-600 tw-bg-gray-100 tw-px-2 tw-py-1 tw-rounded-md">{{ range.label }}</span>
        </div>
      </div>
  
      <!-- Progress Bar with Highlighted Ranges -->
      <div class="tw-relative">
        <div class="tw-relative tw-mt-2 tw-h-4 tw-rounded-full tw-bg-gray-200 tw-overflow-hidden tw-flex">
          <div v-for="(range, index) in ranges" 
               :key="index" 
               class="tw-h-full tw-transition-all tw-duration-500"
               :class="range.color"
               :style="{ width: range.width + '%' }">
          </div>
        </div>
  
        <!-- Progress Indicator -->
        <div class="tw-absolute tw-top-[-14px] tw-translate-x-[-50%] tw-bg-emerald-500 tw-text-white tw-rounded-full tw-p-2 tw-shadow-xl tw-border-2 tw-border-white"
             :style="$i18n.locale == 'ar' ? { right: currentPercentage + '%', transform: 'scaleX(-100%)' } : { left: currentPercentage + '%' }">
          <icon icon="mdi:run" class="tw-text-xl" />
        </div>
  
        <!-- "أنت هنا" Text Positioned Dynamically -->
        <p class="tw-absolute tw-top-8 tw-text-sm tw-font-semibold tw-text-gray-700 tw-whitespace-nowrap -tw-translate-x-1/2 rtl:tw-translate-x-0"
           :style="$i18n.locale == 'ar' ? { right: currentPercentage + '%' } : { left: currentPercentage + '%' }">
          {{ $t('common.you-are-here') }}
        </p>
      </div>
    </div>
</template>
  
<script setup>
import { computed } from "vue";
  
const badges = [
  { icon: "mdi:medal-outline", label: "badges.level-1", bgColor: "tw-bg-gray-400", iconColor: "tw-text-white", stars: 0 },
  { icon: "mdi:medal", label: "badges.level-2", number: "100", bgColor: "tw-bg-blue-500", iconColor: "tw-text-white", stars: 1 },
  { icon: "mdi:medal", label: "badges.level-3", number: "300", bgColor: "tw-bg-orange-500", iconColor: "tw-text-white", stars: 2 },
  { icon: "mdi:crown", label: "badges.level-4", number: "500", bgColor: "tw-bg-yellow-500", iconColor: "tw-text-white", stars: 3 },
];

const maxAmount = 600;
const currentAmount = 540; // Change dynamically

const ranges = [
  { label: "0 - 100", width: (100 / maxAmount) * 100, color: "tw-bg-gray-300" },
  { label: "100 - 300", width: (200 / maxAmount) * 100, color: "tw-bg-blue-300" },
  { label: "300 - 500", width: (200 / maxAmount) * 100, color: "tw-bg-orange-300" },
  { label: "500+", width: (100 / maxAmount) * 100, color: "tw-bg-yellow-300" },
];

const currentPercentage = computed(() => (currentAmount / maxAmount) * 100);
</script>
